/**
 * TICKET-DEROG-04 (blocage provisoire) : textes vus par le participant quand
 * une dérogation d'âge manque (4L Trophy : 29 ans ou plus au départ). Wording
 * simple, à valider par l'équipe du 4L Trophy (Floran).
 *
 * Aucun e-mail automatique n'est envoyé après la validation dans ce lot : les
 * textes n'en promettent pas. Le formulaire de demande (DEROG-02) n'existe pas
 * encore : ils renvoient vers l'adresse de la procédure de dérogation (celle de
 * la popin du BPI).
 *
 * Un seul endroit pour les textes : le wizard les affiche, les tests les lisent.
 */

/** Adresse de la procédure de dérogation (popin BPI `DerogationNotice`). */
export const BED_DEROGATION_CONTACT_EMAIL = 'contact@4ltrophy.com';

/** Bulletin enregistré, solde à payer : à la place du paiement. */
export const BED_DEROGATION_PENDING_MESSAGE = `Le paiement du solde sera possible une fois votre dérogation d’âge validée par l’équipe du 4L Trophy. Si vous n’avez pas encore fait la demande, écrivez à ${BED_DEROGATION_CONTACT_EMAIL}.`;

/**
 * Rien à payer, bulletin DÉJÀ envoyé (mise à jour des pièces acceptée) : c'est
 * l'inscription définitive qui attend la dérogation.
 */
export const BED_DEROGATION_FINAL_PENDING_MESSAGE = `Votre inscription définitive attend la validation de votre dérogation d’âge par l’équipe du 4L Trophy. Si vous n’avez pas encore fait la demande, écrivez à ${BED_DEROGATION_CONTACT_EMAIL}.`;

/** Rien à payer : le bulletin n'est PAS envoyé (son envoi vaut inscription définitive). */
export const BED_DEROGATION_HOLD_TITLE = 'Votre bulletin n’est pas encore envoyé';

export const BED_DEROGATION_HOLD_MESSAGE = `Vos réponses sont enregistrées, mais votre bulletin ne pourra être envoyé qu’une fois votre dérogation d’âge validée par l’équipe du 4L Trophy. Revenez alors sur ce lien pour l’envoyer. Si vous n’avez pas encore fait la demande, écrivez à ${BED_DEROGATION_CONTACT_EMAIL}.`;

/**
 * Sous une date de naissance saisie qui donne 29 ans ou plus au départ de
 * l'événement (copilote ajouté au bulletin). Non fermable : elle annonce ce
 * que le serveur fera. 4L Trophy seulement.
 */
export const BED_DEROGATION_FIELD_NOTICE = `29 ans ou plus au départ de l’événement : une dérogation d’âge, validée par l’équipe du 4L Trophy, est nécessaire. En attendant, le paiement du solde est bloqué (ou, s’il n’y a rien à payer, l’envoi du bulletin). Si la demande n’est pas encore faite, écrivez à ${BED_DEROGATION_CONTACT_EMAIL}.`;

/**
 * Le produit est-il soumis à la limite d'âge ? Même règle que le CRM
 * (`bed_product_has_age_limit`, 00310) : code commençant par « 4lt », ou, sans
 * code, nom commençant par « 4L Trophy ».
 */
export function productHasAgeLimit(
  product: { code?: string | null; name?: string | null } | null | undefined
): boolean {
  if (!product) return false;
  const code = product.code?.trim().toLowerCase();
  if (code) return code.startsWith('4lt');
  return (product.name ?? '').trim().toLowerCase().startsWith('4l trophy');
}
